import React from "react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { avatarSrc } from "@/lib/defaults";
import { mutualLabel } from "@/lib/mutual";

// Lot 533 — « Suivi(e) par … » précédé des petites photos rondes (≤ 3, empilées) des connaissances en commun, façon Instagram.
export const MutualLine = ({ mutual, t, size = 20, className = "", testId }) => {
  const label = mutualLabel(mutual, t);
  if (!label) return null;
  const people = (mutual?.people || []).slice(0, 3);
  return (
    <span className={`inline-flex items-center gap-1.5 min-w-0 ${className}`} data-testid={testId} data-mutual={mutual?.count || 0}>
      {people.length > 0 && (
        <span className="flex shrink-0" style={{ marginRight: 2 }} data-testid={testId ? `${testId}-avatars` : undefined}>
          {people.map((p, i) => (
            <Avatar key={p.id} className="ring-2" style={{ height: size, width: size, marginLeft: i ? -Math.round(size / 3) : 0, "--tw-ring-color": "var(--yalola-surface)" }}>
              <AvatarImage src={avatarSrc(p)} alt="" />
              <AvatarFallback className="text-[9px]">{p.name?.[0]}</AvatarFallback>
            </Avatar>
          ))}
        </span>
      )}
      <span className="truncate">{label}</span>
    </span>
  );
};

export default MutualLine;
